import { isCustomerSubscriptionCanceled } from 'src/data/customer';

import { useCurrentCustomer } from './';

export const useIsCustomerSubscriptionCanceled = () => {
  const customer = useCurrentCustomer();

  return isCustomerSubscriptionCanceled(customer);
};
